import * as React from 'react';
import { welcomePage } from '../../../consts/pageTypes';
import { countriesPortalMapping } from '../../../consts/welcomePage';
import { eventTracker } from '../../../helpers/EventTracker/EventTracker';
import { FormContainer, SuccessMessage, ErrorMessage } from './FormContainer';

interface IProps {
    newsletterHeadline: string;
    signUp: Function;
    pageType?: string;
    pageUrl?: string;
    contentEndpoint?: string;
    portalId?: string;
}

interface IState {
    input: string;
    country: string;
    countryIndex: string;
    pageUrl: string;
    harbour: string;
    harbourIndex: string;
    promoter: string;
    promoterIndex: string;
    isValid: boolean;
    isCountryValid: boolean;
    isHarbourValid: boolean;
    isPromoterValid: boolean;
    isSuccessful: boolean;
    submitError: boolean;
    isLoading: boolean;
    isFormSubmittedOnce: boolean;
}

export function validateEmail(email) {
    const mailRegExp = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return mailRegExp.test(email);
}

const validateField = (field, value) => (field === 'email' ? validateEmail(value) : value !== '');

export class Form extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            input: '',
            country: '',
            countryIndex: '',
            pageUrl: '',
            harbour: '',
            harbourIndex: '',
            promoter: '',
            promoterIndex: '',
            isValid: true,
            isCountryValid: true,
            isHarbourValid: true,
            isPromoterValid: true,
            isSuccessful: false,
            submitError: false,
            isLoading: false,
            isFormSubmittedOnce: false,
        };
    }

    handleChange = (field) => (ev) => {
        if (field === 'country') {
            this.setState({
                countryIndex: ev.value,
                country: ev.label,
                isCountryValid: validateField('country', ev.value),
            });
            return;
        }
        if (field === 'harbour') {
            this.setState({
                harbourIndex: ev.value,
                harbour: ev.label,
                isHarbourValid: validateField('harbour', ev.value),
            });
            return;
        }
        if (field === 'promoter') {
            this.setState({
                promoterIndex: ev.value,
                promoter: ev.label,
                isPromoterValid: validateField('promoter', ev.value),
            });
            return;
        }
        this.setState({
            input: ev.target.value,
            isValid: this.state.isValid || validateEmail(ev.target.value),
        });
    };

    formSubmitHandler = (ev) => {
        ev.preventDefault();
        const isEmailValid = validateEmail(this.state.input);
        if (isEmailValid) {
            this.setState({ isLoading: true });
            this.props
                .signUp(this.state.input, `${this.props.portalId} signuppage`)
                .then((response) => {
                    this.setState({
                        input: '',
                        isSuccessful: true,
                        submitError: false,
                        isLoading: false,
                    });
                    eventTracker.track({
                        category: 'newsletter',
                        action: 'signup-page',
                        label: this.props.pageUrl || '',
                    });
                })
                .catch((error) => {
                    this.setState({
                        submitError: true,
                        isLoading: false,
                    });
                });
        }
        this.setState({ isValid: isEmailValid, isFormSubmittedOnce: true });
    };

    welcomePageFormSubmitHandler = (ev) => {
        ev.preventDefault();
        const isEmailValid = validateField('email', this.state.input);
        const isCountrySelected = validateField('country', this.state.countryIndex);
        const isHarbourSelected = validateField('harbour', this.state.harbourIndex);
        const isPromoterSelected = validateField('promoter', this.state.promoterIndex);

        if (isEmailValid && isCountrySelected && isHarbourSelected && isPromoterSelected) {
            this.setState({ isLoading: true });
            this.props
                .signUp(
                    this.state.input,
                    countriesPortalMapping[this.state.countryIndex],
                    this.state.harbour,
                )
                .then(
                    (response) => {
                        this.setState({
                            input: '',
                            isSuccessful: true,
                            submitError: false,
                            isLoading: false,
                        });
                        eventTracker.track({
                            category: 'Port Sign Up',
                            action: 'sign up',
                            label: `${this.state.country}|${this.state.harbour}|${this.state.promoter}`,
                        });
                    },
                    (error) => {
                        this.setState({
                            submitError: true,
                            isLoading: false,
                        });
                    },
                );
        }
        this.setState({
            isValid: isEmailValid,
            isCountryValid: isCountrySelected,
            isHarbourValid: isHarbourSelected,
            isPromoterValid: isPromoterSelected,
            isFormSubmittedOnce: true,
        });
    };

    render() {
        const { newsletterHeadline, pageType } = this.props;
        const isWelcomePage = pageType === welcomePage;
        const formProps = {
            ...this.state,
            newsletterHeadline,
            formSubmitHandler: isWelcomePage
                ? this.welcomePageFormSubmitHandler
                : this.formSubmitHandler,
            handleChange: this.handleChange,
            pageType: this.props.pageType,
            contentEndpoint: this.props.contentEndpoint,
            isWelcomePage,
            portal: `${this.props.contentEndpoint}${
                countriesPortalMapping[this.state.countryIndex]
            }?utm_source=gph_signup&utm_medium=cta`,
        };
        return this.state.isSuccessful ? (
            <SuccessMessage {...formProps} />
        ) : this.state.submitError ? (
            <ErrorMessage {...formProps} />
        ) : (
            <FormContainer {...formProps} />
        );
    }
}
